// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/Fonts/N27-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/Images/noise_login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: N27-Bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  @font-face {
    font-family: N27-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: N27-Italic;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  @font-face {
    font-family: N27-Italic-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  .signup-page-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .nav-bar-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height:4.875rem;
    width:100%;
   
  }
  .page-navigation-container{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.8% 3.6% 1% 4.4%;
    height: 2.62rem;
    width: 92.2%;
  }
  .nav-button-container{
    display: flex;
    height: 100%;
    width:8rem;
    margin-right: 2.5rem;
  }
  .signup-container{
    display: flex;
    flex-direction: row;
    width: 92%;
    padding: 6.1% 4% 3% 4%;
    justify-content: space-between;
    align-items: center;
    height: 30.8rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: 100% 100%;
  }
  .left-box-container{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    height:35rem;
    width:39rem;
    /* margin-bottom: 6.3rem; */
  }
  .left-box{
    font-family: PP-Nuebit;
    font-size: 10.5rem;
    text-align: left;
    line-height: 80%;
    margin-bottom: 1.5rem;
  }
  .signup-right-box-container{
   display: flex;
   flex-direction: column;
   justify-content: flex-start;
   align-items: center;
   height:37rem;
   width:35rem;
   background-color: #FFFFFF;
   border: 1px solid black;
  }
  .signup-right-box{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height:100%;
    width:92%;
    padding:5.74% 4% 3.5% 4%;
  }
  .signup-header-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height:3.4rem;
    width:80%;
  }
  .signup-header{
    font-family: N27-Light;
    font-size:1.55rem;
    text-align: left;
  }
  .input-field-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 1.5rem;

  }
 
.input-field {
  background-color: #f5f5f5; 
  border: none; 
  border-bottom: 2px solid black; 
  font-size: 1rem; 
  padding: 9px 20px; 
  outline: none; 
  width: 100%; 
  box-sizing: border-box;
  margin-bottom: 1rem; 
}
.input-field::placeholder {
  color: black; 
  font-family: N27-Italic-Light ; 
}
.input-field:focus {
  border-bottom: 2px solid #555; 
}

.signup-box{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:3rem;
  width:10rem;
  height:3.5rem;
  cursor: pointer;
}
.signup-link-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:1.5rem;
  width:20.625rem;
  height:0.875rem
}
.signup-link{
  font-family: N27;
  font-size: 1rem;
  text-align: center;
}
.signup-link a, .signup-link Link {
  color: #514FEF; 
  text-decoration: none; 
}

.signup-link a:hover, .signup-link Link:hover {
  text-decoration: underline; 
  color: #514FEF; 
}
.crs-error-message-container {
  display: flex;
  padding:0rem 0 1rem 1rem;
  border: 1pt solid #FF3B3B;
  background-color: #FFF2F2;
  justify-content: space-between;
  z-index: 10;
  position: fixed;
  margin-top: 3.3rem;
  width: 32%;
}
.crs-error-container{
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.crs-eror-header-container{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.8rem;
}
.crs-info-icon{
  height:1.25rem;
  width: 1.25rem;
  margin-right: 0.5rem;
}
.crs-error-header{
  font-family:N27-Medium;
  font-size: 1.25rem;
  text-align: left;
  margin: 0;
  color: #F71111;
}
.crs-error-content-container{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-left: 1.8rem;
  height:2.4rem;
}
.crs-error-content{
  font-family:N27-Medium;
  font-size: 1.25rem;
  text-align: left;
  margin: 0;
  color: #3C3C3C;
}
.crs-x-icon-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;
  margin: 0.5rem 0.5rem;
}
.crs-error-outer-counter{
  display: flex;
  width:100%;
  justify-content: space-between;
}
.crs-x-icon{
  height:0.729rem;
  width:0.729rem;
}

.input-error { 
  background-color: #ffe5e5 !important;
  border: 2px solid #FF3B3B !important; 
  border-bottom: 2px solid #FF3B3B !important;
  font-size: 1rem; 
  padding: 9px 20px; 
  outline: none; 
  width: 100%; 
  box-sizing: border-box;
  margin-bottom: 1rem; 
}
.input-error::placeholder {
  color: black; 
  font-family: N27-Italic-Light ; 
}
.crs-error-content a, .error-content Link {
  color: #3C3C3C; 
  text-decoration: underline;
  font-family: N27-Bold; 
} 
.crs-error-content a:hover, .error-content Link:hover {
  text-decoration: underline; 
  color: black; 
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/CourseLogin/Crsignup.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAoD;EACtD;EACA;IACE,gBAAgB;IAChB,4CAAiD;EACnD;EACA;IACE,qBAAqB;IACrB,4CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,4CAA+C;EACjD;EACA;IACE,uBAAuB;IACvB,4CAAuD;EACzD;EACA;IACE,6BAA6B;IAC7B,4CAAqD;EACvD;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;;EAEZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yDAA+D;IAC/D,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;GACC,aAAa;GACb,sBAAsB;GACtB,2BAA2B;GAC3B,mBAAmB;GACnB,YAAY;GACZ,WAAW;GACX,yBAAyB;GACzB,uBAAuB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;;EAEpB;;AAEF;EACE,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,YAAY;AACd","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27;\n    src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n  }\n  @font-face {\n    font-family: N27-Bold;\n    src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27-Light;\n    src: url(\"../../../assets/Fonts/N27-Light.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic;\n    src: url(\"../../../assets/Fonts/N27-RegularItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic-Light;\n    src: url(\"../../../assets/Fonts/N27-LightItalic.otf\");\n  }\n  .signup-page-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .nav-bar-container{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height:4.875rem;\n    width:100%;\n   \n  }\n  .page-navigation-container{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.8% 3.6% 1% 4.4%;\n    height: 2.62rem;\n    width: 92.2%;\n  }\n  .nav-button-container{\n    display: flex;\n    height: 100%;\n    width:8rem;\n    margin-right: 2.5rem;\n  }\n  .signup-container{\n    display: flex;\n    flex-direction: row;\n    width: 92%;\n    padding: 6.1% 4% 3% 4%;\n    justify-content: space-between;\n    align-items: center;\n    height: 30.8rem;\n    background-image: url('../../../assets/Images/noise_login.png');\n    background-repeat: no-repeat;\n    background-color: transparent;\n    background-size: 100% 100%;\n  }\n  .left-box-container{\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    height:35rem;\n    width:39rem;\n    /* margin-bottom: 6.3rem; */\n  }\n  .left-box{\n    font-family: PP-Nuebit;\n    font-size: 10.5rem;\n    text-align: left;\n    line-height: 80%;\n    margin-bottom: 1.5rem;\n  }\n  .signup-right-box-container{\n   display: flex;\n   flex-direction: column;\n   justify-content: flex-start;\n   align-items: center;\n   height:37rem;\n   width:35rem;\n   background-color: #FFFFFF;\n   border: 1px solid black;\n  }\n  .signup-right-box{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    height:100%;\n    width:92%;\n    padding:5.74% 4% 3.5% 4%;\n  }\n  .signup-header-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    height:3.4rem;\n    width:80%;\n  }\n  .signup-header{\n    font-family: N27-Light;\n    font-size:1.55rem;\n    text-align: left;\n  }\n  .input-field-container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    margin-top: 1.5rem;\n\n  }\n \n.input-field {\n  background-color: #f5f5f5; \n  border: none; \n  border-bottom: 2px solid black; \n  font-size: 1rem; \n  padding: 9px 20px; \n  outline: none; \n  width: 100%; \n  box-sizing: border-box;\n  margin-bottom: 1rem; \n}\n.input-field::placeholder {\n  color: black; \n  font-family: N27-Italic-Light ; \n}\n.input-field:focus {\n  border-bottom: 2px solid #555; \n}\n\n.signup-box{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top:3rem;\n  width:10rem;\n  height:3.5rem;\n  cursor: pointer;\n}\n.signup-link-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top:1.5rem;\n  width:20.625rem;\n  height:0.875rem\n}\n.signup-link{\n  font-family: N27;\n  font-size: 1rem;\n  text-align: center;\n}\n.signup-link a, .signup-link Link {\n  color: #514FEF; \n  text-decoration: none; \n}\n\n.signup-link a:hover, .signup-link Link:hover {\n  text-decoration: underline; \n  color: #514FEF; \n}\n.crs-error-message-container {\n  display: flex;\n  padding:0rem 0 1rem 1rem;\n  border: 1pt solid #FF3B3B;\n  background-color: #FFF2F2;\n  justify-content: space-between;\n  z-index: 10;\n  position: fixed;\n  margin-top: 3.3rem;\n  width: 32%;\n}\n.crs-error-container{\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.crs-eror-header-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.8rem;\n}\n.crs-info-icon{\n  height:1.25rem;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n.crs-error-header{\n  font-family:N27-Medium;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0;\n  color: #F71111;\n}\n.crs-error-content-container{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-left: 1.8rem;\n  height:2.4rem;\n}\n.crs-error-content{\n  font-family:N27-Medium;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0;\n  color: #3C3C3C;\n}\n.crs-x-icon-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  cursor: pointer;\n  margin: 0.5rem 0.5rem;\n}\n.crs-error-outer-counter{\n  display: flex;\n  width:100%;\n  justify-content: space-between;\n}\n.crs-x-icon{\n  height:0.729rem;\n  width:0.729rem;\n}\n\n.input-error { \n  background-color: #ffe5e5 !important;\n  border: 2px solid #FF3B3B !important; \n  border-bottom: 2px solid #FF3B3B !important;\n  font-size: 1rem; \n  padding: 9px 20px; \n  outline: none; \n  width: 100%; \n  box-sizing: border-box;\n  margin-bottom: 1rem; \n}\n.input-error::placeholder {\n  color: black; \n  font-family: N27-Italic-Light ; \n}\n.crs-error-content a, .error-content Link {\n  color: #3C3C3C; \n  text-decoration: underline;\n  font-family: N27-Bold; \n} \n.crs-error-content a:hover, .error-content Link:hover {\n  text-decoration: underline; \n  color: black; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
